import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['screen', 'dot', 'progress', 'restart', 'stepLabel', 'nation', 'instrument', 'year', 'areaCard', 'areaPanel', 'mapRegion']
  static values = { step: { type: Number, default: 0 } }

  connect() {
    this.showStep()
  }

  next() {
    this.stepValue = Math.min(this.stepValue + 1, this.screenTargets.length - 1)
    this.showStep()
  }

  back() {
    this.stepValue = Math.max(this.stepValue - 1, 0)
    this.showStep()
  }

  goTo(event) {
    this.stepValue = Number(event.currentTarget.dataset.step)
    this.showStep()
  }

  restart() {
    this.stepValue = 0
    this.showStep()
  }

  choose(event) {
    const group = event.currentTarget.dataset.group
    this[`${group}Target`].value = event.currentTarget.dataset.value

    this.element.querySelectorAll(`[data-group="${group}"]`).forEach((button) => {
      button.classList.remove('border-blue-700', 'bg-blue-700', 'text-white')
      button.classList.add('border-gray-200', 'bg-white', 'text-blue-900')
      button.setAttribute('aria-pressed', 'false')
    })

    event.currentTarget.classList.remove('border-gray-200', 'bg-white', 'text-blue-900')
    event.currentTarget.classList.add('border-blue-700', 'bg-blue-700', 'text-white')
    event.currentTarget.setAttribute('aria-pressed', 'true')

    if (group === 'nation') {
      this.mapRegionTargets.forEach((region) => {
        region.classList.toggle('fill-blue-600', region.dataset.nation === event.currentTarget.dataset.value)
        region.classList.toggle('fill-blue-200', region.dataset.nation !== event.currentTarget.dataset.value)
      })
    }
  }

  selectArea(event) {
    const selectedArea = event.currentTarget.dataset.area
    this.areaCardTargets.forEach((card) => {
      const selected = card.dataset.area === selectedArea
      card.classList.toggle('ring-4', selected)
      card.classList.toggle('ring-offset-2', selected)
      card.setAttribute('aria-pressed', selected)
    })
    this.areaPanelTargets.forEach((panel) => panel.classList.toggle('hidden', panel.dataset.area !== selectedArea))
  }

  showStep() {
    this.screenTargets.forEach((screen, index) => screen.classList.toggle('hidden', index !== this.stepValue))
    const started = this.stepValue > 0
    this.progressTarget.classList.toggle('hidden', !started)
    this.restartTarget.classList.toggle('hidden', !started)
    this.stepLabelTarget.textContent = started ? `Step ${this.stepValue} of ${this.screenTargets.length - 1}` : ''
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle('bg-blue-700', index <= this.stepValue)
      dot.classList.toggle('bg-gray-200', index > this.stepValue)
      dot.setAttribute('aria-current', index === this.stepValue ? 'step' : 'false')
    })
    this.element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}